import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export class ContentAlreadyPinnedToSectionError extends CodedError {
  static get errorName() {
    return errorCodes.contentAlreadyPinnedToSectionError.code;
  }

  constructor(message: string = errorCodes.contentAlreadyPinnedToSectionError.message) {
    super(message);
    this.code = errorCodes.contentAlreadyPinnedToSectionError.code;
    this.message = `${message} ${errorCodes.contentAlreadyPinnedToSectionError.code}`;
    this.name = errorCodes.contentAlreadyPinnedToSectionError.name;
  }
}
